import { Component, OnInit } from '@angular/core';
import {NativeService} from "../../../app-common/services/native/native.service";

@Component({
  selector: 'app-force-update-screen',
  templateUrl: './force-update-screen.component.html',
  styleUrls: ['./force-update-screen.component.scss']
})
export class ForceUpdateScreenComponent implements OnInit {

  constructor(private nativeService: NativeService) { }

  ngOnInit(): void {
  }

  openDownloadPage() {
    this.nativeService.openInBrowser("https://updates.globalofficedatahub.com/");
  }

}
